import axios from "axios";
import secureLocalStorage from "react-secure-storage";
export const get_all_notification = async (page = 1, per_page = 10, is_people = false) => {
  const endpoint = is_people
    ? '/api/get-all-people-notifications'
    : '/api/get-all-notifications'

  const response = await axios.post(`${secureLocalStorage.getItem("baseURL")}${endpoint}`, {
    per_page,
    page
  })

  return response.data
}
export const get_all_unread_notifications = async (is_people = false) => {
  const endpoint = is_people
    ? '/api/get-people-unread-notifications'
    : '/api/unread-notifications'

  const response = await axios.get(`${secureLocalStorage.getItem("baseURL")}${endpoint}`)

  return response.data
}
export const get_read_notification = async (id, is_people = false) => {
  const endpoint = is_people
    ? `/api/get-people-read-notification/${id}`
    : `/api/read-notification/${id}`

  const response = await axios.get(`${secureLocalStorage.getItem("baseURL")}${endpoint}`)
  return response.data
}